import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const meatballMenuPopUpEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "meatball-menu-popup" */ './ui/popup'),
	),
	getPreloadProps: () => ({}),
});
